// 基准大小
const baseSize = 16
// 设置 rem 函数
const setRem = () => {
  // 获取页面宽度
  let width = document.documentElement.clientWidth
  if (width < 1200) width = 1200
  // 当前页面宽度相对于 1920 宽的缩放比例，可根据自己需要修改。
  const scale = width / 1920
  // 设置页面根节点字体大小
  document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + 'px'
}
// 初始化
setRem()
// 改变窗口大小时重新设置 rem
window.onresize = e => {
  setRem()
}



// WEBPACK FOOTER //
// ./src/plugin/rem.js